import instance from '@apis/instance';
import { TermRow, TermsResponse } from '@models/term';

class TermApi {
    static getTermsByCategory(termCategoryId: string): Promise<TermsResponse> {
        return instance.get(`/v0/terms-category/${termCategoryId}/terms`);
    }

    static getMainTermByCategory(termCategoryId: string): Promise<TermRow> {
        return instance.get(`/v0/terms-category/${termCategoryId}/main-terms`);
    }
}

export default TermApi;
